export const REFINE_BY = {
  NONE: 'none',
  UNREAD_MESSAGES: 'hasUnreadMessages',
  NEEDS_FIRST_TOUCH: 'unansweredOptIns',
  MENTIONS: 'mentions',
  UNADDRESSED_MESSAGES: 'hasUnaddressedMessage',
  AUTO_ADDRESSED: 'autoAddressed',
};

export const REFINE_BY_ITEMS = ({
  unaddressedEnabled,
  autoAddressedEnabled,
}) => [
  {
    labelKey: 'messageTypeAllMessages',
    value: REFINE_BY.NONE,
  },
  ...(unaddressedEnabled
    ? [
        {
          labelKey: 'messageTypeUnaddressedMessages',
          value: REFINE_BY.UNADDRESSED_MESSAGES,
        },
      ]
    : []),
  ...(!unaddressedEnabled
    ? [
        {
          labelKey: 'messageTypeUnreadMessages',
          value: REFINE_BY.UNREAD_MESSAGES,
        },
      ]
    : []),
  ...(autoAddressedEnabled
    ? [
        {
          labelKey: 'messageTypeAutoAddressed',
          value: REFINE_BY.AUTO_ADDRESSED,
        },
      ]
    : []),
  {
    labelKey: 'messageTypeNeedsFirstTouch',
    value: REFINE_BY.NEEDS_FIRST_TOUCH,
  },
  {
    labelKey: 'messageTypeMentionsReplies',
    value: REFINE_BY.MENTIONS,
  },
];
